// extracted by mini-css-extract-plugin
export default {"active":"view-module__[local]___AZ5yU","group":"view-module__[local]___ge2n1"};